document.addEventListener('DOMContentLoaded',()=>{
  const h=document.querySelector('[data-site-header]');
  const onScroll=()=>h&&h.classList.toggle('scrolled',window.scrollY>16);onScroll();window.addEventListener('scroll',onScroll,{passive:true});
  const lb=document.querySelector('.locale-button'),lm=document.querySelector('.locale-menu');
  if(lb&&lm){lb.addEventListener('click',()=>{const o=lb.getAttribute('aria-expanded')==='true';lb.setAttribute('aria-expanded',String(!o));lm.classList.toggle('open',!o)});document.addEventListener('click',e=>{if(!e.target.closest('.locale-form')){lb.setAttribute('aria-expanded','false');lm.classList.remove('open')}})}
  const mb=document.querySelector('.mobile-menu'),md=document.querySelector('.mobile-drawer');
  if(mb&&md){mb.addEventListener('click',()=>{const o=mb.getAttribute('aria-expanded')==='true';mb.setAttribute('aria-expanded',String(!o));md.classList.toggle('open',!o);md.setAttribute('aria-hidden',String(o));document.body.classList.toggle('menu-open',!o)});md.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{mb.setAttribute('aria-expanded','false');md.classList.remove('open');md.setAttribute('aria-hidden','true');document.body.classList.remove('menu-open')}))}
  document.querySelectorAll('[data-cookie-preferences]').forEach(btn=>btn.addEventListener('click',()=>{try{if(window.Shopify&&Shopify.customerPrivacy&&typeof Shopify.customerPrivacy.showPreferences==='function'){Shopify.customerPrivacy.showPreferences()}else{window.location.href='/policies/privacy-policy'}}catch(e){window.location.href='/policies/privacy-policy'}}));
});

// Product media gallery: one main image at a time, arrows, and thumbnail navigation.
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
    const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
    const prev=gallery.querySelector('[data-gallery-prev]');
    const next=gallery.querySelector('[data-gallery-next]');
    if(!slides.length) return;

    let index=Math.max(0,slides.findIndex(slide=>slide.classList.contains('is-active')));

    const show=(newIndex,{scrollThumb=true}={})=>{
      index=(newIndex+slides.length)%slides.length;
      slides.forEach((slide,i)=>{
        const active=i===index;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',String(!active));
        if(!active){
          slide.querySelectorAll('video').forEach(video=>{ try{ video.pause(); }catch(e){} });
        }
      });
      thumbs.forEach((thumb,i)=>{
        const active=i===index;
        thumb.classList.toggle('is-active',active);
        thumb.setAttribute('aria-current',active?'true':'false');
      });
      if(scrollThumb&&thumbs[index]) thumbs[index].scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
    };

    prev?.addEventListener('click',()=>show(index-1));
    next?.addEventListener('click',()=>show(index+1));
    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i,{scrollThumb:false})));

    gallery.addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft'){event.preventDefault();show(index-1)}
      if(event.key==='ArrowRight'){event.preventDefault();show(index+1)}
    });

    const section=gallery.closest('[data-product-section]');
    const variantSelect=section?.querySelector('[data-product-variant-select]');
    variantSelect?.addEventListener('change',()=>{
      const mediaId=variantSelect.selectedOptions[0]?.dataset.mediaId;
      if(!mediaId) return;
      const target=slides.findIndex(slide=>slide.dataset.mediaId===mediaId);
      if(target>=0) show(target);
    });

    show(index,{scrollThumb:false});
  });
});

// Native Shopify option pills: update the real variant ID, price, availability, URL, and gallery image.
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-product-section]').forEach(section=>{
    const select=section.querySelector('[data-product-variant-select]');
    const data=section.querySelector('[data-product-variants]');
    const pills=[...section.querySelectorAll('[data-option-value]')];
    if(!select||!data||!pills.length) return;
    let variants=[];
    try{variants=JSON.parse(data.textContent)}catch(e){return}
    const groups=[...section.querySelectorAll('[data-option-position]')];
    const price=section.querySelector('[data-product-price]');
    const add=section.querySelector('[data-add-to-cart]');
    const formatMoney=(cents)=>{
      const currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
      try{return new Intl.NumberFormat(undefined,{style:'currency',currency}).format(cents/100)}catch(e){return '$'+(cents/100).toFixed(2)}
    };
    const currentValues=()=>groups.map(group=>group.querySelector('.variant-pill.is-selected')?.dataset.optionValue||'');
    const refresh=()=>{
      const values=currentValues();
      const variant=variants.find(v=>v.options.every((val,i)=>val===values[i]));
      if(!variant) return;
      select.value=String(variant.id);
      if(price) price.textContent=formatMoney(variant.price);
      if(add){add.disabled=!variant.available;add.textContent=variant.available?'ADD TO CART':'SOLD OUT'}
      const opt=select.querySelector(`option[value="${variant.id}"]`);
      if(opt){opt.selected=true;select.dispatchEvent(new Event('change',{bubbles:true}))}
      try{const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url)}catch(e){}
    };
    pills.forEach(pill=>pill.addEventListener('click',()=>{
      const pos=pill.dataset.optionPosition;
      section.querySelectorAll(`[data-option-position="${pos}"] .variant-pill`).forEach(btn=>{btn.classList.toggle('is-selected',btn===pill);btn.setAttribute('aria-pressed',btn===pill?'true':'false')});
      refresh();
    }));
  });
});

// Custom Shopify collection sort dropdown with Yum-Wick Light Blue selection styling.
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-sort-dropdown]').forEach(dropdown=>{
    const form=dropdown.closest('[data-sort-form]');
    const select=dropdown.querySelector('[data-sort-select]');
    const toggle=dropdown.querySelector('[data-sort-toggle]');
    const menu=dropdown.querySelector('[data-sort-menu]');
    const current=dropdown.querySelector('[data-sort-current]');
    const options=[...dropdown.querySelectorAll('[data-sort-value]')];
    if(!form||!select||!toggle||!menu||!options.length) return;

    const close=()=>{
      dropdown.classList.remove('is-open');
      toggle.setAttribute('aria-expanded','false');
    };
    const open=()=>{
      dropdown.classList.add('is-open');
      toggle.setAttribute('aria-expanded','true');
    };

    toggle.addEventListener('click',()=>dropdown.classList.contains('is-open')?close():open());
    options.forEach(option=>option.addEventListener('click',()=>{
      const value=option.dataset.sortValue;
      select.value=value;
      if(current) current.textContent=option.querySelector('span')?.textContent||option.textContent.trim();
      options.forEach(item=>{
        const selected=item===option;
        item.classList.toggle('is-selected',selected);
        item.setAttribute('aria-selected',selected?'true':'false');
      });
      close();
      form.submit();
    }));
    document.addEventListener('click',event=>{if(!dropdown.contains(event.target)) close()});
    dropdown.addEventListener('keydown',event=>{
      if(event.key==='Escape'){close();toggle.focus()}
      if(event.key==='ArrowDown'&&document.activeElement===toggle){event.preventDefault();open();(options.find(o=>o.classList.contains('is-selected'))||options[0]).focus()}
    });
  });
});


// Cart drawer + add-to-cart preview behavior.
(function(){
  const FREE_SHIPPING_THRESHOLD = 3000;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  const money = cents => {
    const currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
    try{return new Intl.NumberFormat(undefined,{style:'currency',currency}).format((cents||0)/100)}catch(e){return '$'+((cents||0)/100).toFixed(2)}
  };
  const escapeHtml = (str='') => String(str).replace(/[&<>"']/g, s => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[s]));
  const drawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('[data-cart-drawer-backdrop]');
  if(!drawer || !backdrop) return;
  const body = drawer.querySelector('[data-cart-drawer-body]');
  const footer = drawer.querySelector('[data-cart-drawer-footer]');
  const subtotal = drawer.querySelector('[data-cart-drawer-subtotal]');
  const shippingWrap = drawer.querySelector('[data-cart-drawer-shipping]');
  const shippingText = drawer.querySelector('[data-cart-drawer-shipping-text]');
  const shippingBar = drawer.querySelector('[data-cart-drawer-progress]');
  const openDrawer=()=>{drawer.hidden=false;backdrop.hidden=false;drawer.setAttribute('aria-hidden','false');document.body.classList.add('cart-drawer-open')};
  const closeDrawer=()=>{drawer.setAttribute('aria-hidden','true');backdrop.hidden=true;document.body.classList.remove('cart-drawer-open')};
  drawer.querySelectorAll('[data-cart-drawer-close]').forEach(btn=>btn.addEventListener('click',closeDrawer));
  backdrop.addEventListener('click',closeDrawer);
  document.addEventListener('keydown',e=>{if(e.key==='Escape') closeDrawer()});
  const updateCount = count => document.querySelectorAll('.cart-link span').forEach(el=>el.textContent=count);
  const ensureCountBubble = count => {
    document.querySelectorAll('.cart-link').forEach(link=>{
      let bubble = link.querySelector('span');
      if(count>0 && !bubble){bubble=document.createElement('span');link.appendChild(bubble)}
      if(bubble) bubble.textContent=count;
    });
  };
  const renderCart = cart => {
    ensureCountBubble(cart.item_count||0);
    updateCount(cart.item_count||0);
    subtotal.textContent = money(cart.total_price||0);
    footer.hidden = !cart.item_count;
    shippingWrap.hidden = false;
    const remaining = Math.max(FREE_SHIPPING_THRESHOLD - (cart.total_price||0), 0);
    shippingText.textContent = remaining > 0 ? `Spend ${money(remaining)} more and get free shipping!` : 'You unlocked free shipping!';
    shippingBar.style.width = `${Math.min(((cart.total_price||0)/FREE_SHIPPING_THRESHOLD)*100, 100)}%`;
    if(!cart.item_count){
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      return;
    }
    body.innerHTML = cart.items.map(item => {
      const img = item.image ? `<a class="cart-drawer__item-image" href="${item.url}"><img src="${item.image}" alt="${escapeHtml(item.product_title)}"></a>` : '<div class="cart-drawer__item-image"></div>';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer__item-variant">${escapeHtml(item.variant_title)}</div>` : '';
      return `<div class="cart-drawer__item" data-cart-item-key="${item.key}">
        ${img}
        <div class="cart-drawer__item-meta">
          <a class="cart-drawer__item-title" href="${item.url}">${escapeHtml(item.product_title)}</a>
          ${variant}
          <div class="cart-drawer__item-price">${money(item.final_line_price)}</div>
          <div class="cart-drawer__item-controls">
            <div class="cart-drawer__qty">
              <button type="button" data-cart-qty-change="-1" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-qty-change="1" aria-label="Increase quantity">+</button>
            </div>
            <button type="button" class="cart-drawer__remove" data-cart-remove>Remove</button>
          </div>
        </div>
      </div>`;
    }).join('');
  };
  const fetchCart = async() => {
    const response = await fetch(root + 'cart.js', {headers:{'Accept':'application/json'}});
    if(!response.ok) throw new Error('Could not load the cart.');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };
  const changeCart = async(key, quantity) => {
    const response = await fetch(root + 'cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id:key, quantity})
    });
    if(!response.ok) throw new Error('Unable to update cart.');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };
  drawer.addEventListener('click', async event => {
    const remove = event.target.closest('[data-cart-remove]');
    const step = event.target.closest('[data-cart-qty-change]');
    if(!remove && !step) return;
    const item = event.target.closest('[data-cart-item-key]');
    if(!item) return;
    const key = item.getAttribute('data-cart-item-key');
    const qty = parseInt(item.querySelector('.cart-drawer__qty span')?.textContent || '1',10);
    try{
      if(remove) await changeCart(key, 0);
      if(step) await changeCart(key, Math.max(0, qty + parseInt(step.getAttribute('data-cart-qty-change'),10)));
    }catch(error){alert(error.message || 'Unable to update cart.')}
  });
  const checkoutBtn = drawer.querySelector('[data-cart-drawer-checkout]');
  if(checkoutBtn){checkoutBtn.addEventListener('click', ()=>window.location.assign(root + 'checkout'))}
  document.querySelectorAll('.cart-link').forEach(link=>link.addEventListener('click', async event => {
    event.preventDefault();
    try{ await fetchCart(); openDrawer(); }catch(error){ window.location.assign(link.getAttribute('href') || root + 'cart'); }
  }));
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form=>{
    if(form.dataset.ywCartBound==='true') return;
    form.dataset.ywCartBound='true';
    form.addEventListener('submit', async event => {
      const submitter = event.submitter || form.querySelector('[type="submit"]');
      if(submitter?.disabled) return;
      event.preventDefault();
      const originalText = submitter?.textContent;
      if(submitter){ submitter.disabled = true; submitter.textContent = 'ADDING…'; }
      try{
        const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Accept':'application/json'}, body:new FormData(form)});
        if(!response.ok){
          let message='Unable to add this item to the cart.';
          try{const err = await response.json(); message = err.description || err.message || message;}catch(e){}
          throw new Error(message);
        }
        await fetchCart();
        openDrawer();
      }catch(error){
        alert(error.message || 'Unable to add this item to the cart. Please try again.');
      }finally{
        if(submitter){ submitter.disabled=false; submitter.textContent=originalText||'ADD TO CART'; }
      }
    });
  });
})();

// Yum-Wick quantity stepper: native Shopify quantity input with branded +/- controls.
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-quantity-stepper]').forEach(stepper=>{
    const input=stepper.querySelector('input[name="quantity"]');
    const minus=stepper.querySelector('[data-quantity-minus]');
    const plus=stepper.querySelector('[data-quantity-plus]');
    if(!input||!minus||!plus) return;
    const clamp=value=>{
      const min=parseInt(input.min||'1',10);
      const max=input.max?parseInt(input.max,10):Infinity;
      return Math.max(min,Math.min(max,Number.isFinite(value)?value:min));
    };
    const set=value=>{
      input.value=clamp(value);
      input.dispatchEvent(new Event('change',{bubbles:true}));
    };
    minus.addEventListener('click',()=>set(parseInt(input.value||'1',10)-1));
    plus.addEventListener('click',()=>set(parseInt(input.value||'1',10)+1));
    input.addEventListener('change',()=>set(parseInt(input.value||'1',10)));
  });
});
